import { Text, openConfirmModal } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

export function useOpenEditCancelConfirmModal() {
  const { t } = useTranslation();

  const openEditCancelConfirmModal = ({ onConfirm }: { onConfirm: () => void }) => {
    openConfirmModal({
      size: 'sm',
      title: t('작성 취소'),
      children: (
        <Text size="md" c="gray.7">
          {t('지금까지 작성한 내용이 사라집니다.')}

          <br />
          {t('정말 취소하시겠습니까?')}
        </Text>
      ),

      labels: {
        confirm: t('확인'),
        cancel: t('취소'),
      },
      onConfirm,
      closeOnClickOutside: true,
      footerType: 'right',
      confirmProps: {
        color: 'infgreen',
        type: 'submit',
        size: 'md',
      },
    });
  };

  return { openEditCancelConfirmModal };
}
